module.exports = __webpack_public_path__ + "FixelDisplay-Medium-c92a2e56edf6522066316bc22b9645c5.woff2";